<p-toast />

<section class="w-full">
  <app-chat-layout [detalleAbierto]="detalleAbierto()">
    <div chatLista class="celula-lista">
    <app-aviso-activar-push [inset]="true" />
    <app-chat-list
      perspectiva="lider"
      emptyMessage="Tu célula está vacía."
      [conversaciones]="conversaciones()"
      [seleccionadaId]="seleccionadaId()"
      [loading]="loading()"
      [mostrarNivel]="mostrarNivel()"
      [mostrarAvisoDatos]="true"
      [cantCulto]="cantCulto()"
      (seleccionar)="onSeleccionar($event)"
    />
    </div>

    <div chatDetalle class="flex flex-column flex-1 min-h-0">
      @if (seleccionada()) {
        <app-chat-header
          [conversacion]="seleccionada()!"
          [mostrarNivel]="mostrarNivel()"
          [mostrarVolver]="true"
          [mostrarCerrar]="false"
          [mostrarEdad]="true"
          (volver)="onVolver()"
        >
          <p-button
            type="button"
            icon="pi pi-ellipsis-v"
            styleClass="p-button-text p-button-sm"
            ariaLabel="Acciones de la persona"
            (onClick)="accionesMenu.toggle($event)"
          />
          <p-menu #accionesMenu [model]="menuItems()" [popup]="true" appendTo="body" />
        </app-chat-header>

        @if (avisos().length > 0) {
          <div class="flex flex-column gap-2 px-3 pt-3">
            @for (aviso of avisos(); track aviso.id) {
              <div
                class="celula-aviso flex align-items-start gap-2 px-3 py-2 border-round text-sm"
                [class.surface-100]="!aviso.eliminar"
                [class.celula-aviso--eliminar]="aviso.eliminar"
              >
                <i
                  class="text-sm mt-1"
                  [ngClass]="aviso.eliminar ? aviso.icono : aviso.icono + ' text-color-secondary'"
                  aria-hidden="true"
                ></i>
                <span>{{ aviso.texto }}</span>
              </div>
            }
          </div>
        }

        <app-chat-messages [mensajes]="seleccionada()!.mensajes" perspectiva="lider" />
        <app-chat-input (enviar)="onEnviar($event)" />
      } @else if (!loading()) {
        <div class="flex flex-1 flex-column align-items-center justify-content-center p-4 text-center">
          <i class="pi pi-users text-3xl text-color-secondary" aria-hidden="true"></i>
          <p class="mt-3 mb-0 font-medium text-color">Tu célula está vacía.</p>
        </div>
      }
    </div>
  </app-chat-layout>
</section>

<p-dialog
  [visible]="motivoVisible()"
  (visibleChange)="onMotivoVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '30rem' }"
  [header]="pedidoActivo()?.header ?? ''"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">{{ pedidoActivo()?.texto }}</p>

  <textarea
    pTextarea
    class="w-full"
    rows="3"
    [ngModel]="motivoTexto()"
    (ngModelChange)="motivoTexto.set($event)"
    placeholder="Motivo"
    aria-label="Motivo"
  ></textarea>

  <div class="flex justify-content-end gap-2 pt-3">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      (onClick)="cerrarMotivo()"
    />
    <p-button
      type="button"
      [label]="pedidoActivo()?.aceptar ?? 'Enviar'"
      icon="pi pi-check"
      [disabled]="motivoInvalido()"
      (onClick)="confirmarMotivo()"
    />
  </div>
</p-dialog>
